<template>
    <div class="cart-delivery-section"
         :class="{ 'active' : stepTwoValid }"
         ref="cartDeliveryContact">
        <h3>
            <span v-show="!submittable" class="step-icon">3</span>
            <span v-show="submittable" class="step-icon">
                <svg xmlns="http://www.w3.org/2000/svg"
                     xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                     width="64px" height="64px" viewBox="0 0 64 64"
                     enable-background="new 0 0 64 64" xml:space="preserve">
                    <path fill="#ffffff"
                          d="M31.051,51c-1.197,0-2.397-0.428-3.354-1.293l-20.9-18.917c-2.047-1.853-2.205-5.015-0.352-7.062 c1.854-2.049,5.015-2.206,7.062-0.352l17.24,15.604l22.631-24.383c1.88-2.023,5.042-2.141,7.066-0.262 c2.023,1.879,2.141,5.042,0.262,7.066l-25.998,28C33.729,50.462,32.394,51,31.051,51z"></path>
                </svg>
            </span>
            Ваши контактные данные
        </h3>
        <form v-if="stepTwoValid" class="form-horizontal">
            <div class="row q-col-gutter-x-sm">
                <div class="col-12 col-sm-4">
                    <q-input
                        dense
                        outlined
                        :class="{ 'is-invalid': hasError('last_name') }"
                        name="last_name"
                        id="last_name"
                        label="Фамилия"
                        v-model="last_name"
                        @input="clearError('last_name')"
                        :error="hasError('last_name')"
                        :error-message="getError('last_name')" />
                </div>
                <div class="col-12 col-sm-4">
                    <q-input
                        dense
                        outlined
                        :class="{ 'is-invalid': hasError('first_name') }"
                        name="first_name"
                        id="first_name"
                        label="Имя"
                        v-model="first_name"
                        @input="clearError('first_name')"
                        :error="hasError('first_name')"
                        :error-message="getError('first_name')" />
                </div>
                <div class="col-12 col-sm-4">
                    <q-input
                        dense
                        outlined
                        :class="{ 'is-invalid': hasError('middle_name') }"
                        name="middle_name"
                        id="middle_name"
                        label="Отчество"
                        v-model="middle_name"
                        @input="clearError('middle_name')"
                        :error="hasError('middle_name')"
                        :error-message="getError('middle_name')" />
                </div>
                <div class="col-12 col-sm-6">
                    <q-input
                        dense
                        outlined
                        :class="{ 'is-invalid': hasError('phone_number') }"
                        name="phone_number"
                        id="phone_number"
                        mask="+7 (###) ###-##-##"
                        label="Ваш телефон"
                        @blur="onBlurPhoneNumber"
                        @focus="focusPhoneNumber"
                        :fill-mask="fillPhoneNumberMask"
                        v-model="phone_number"
                        @input="inputPhoneNumber"
                        :error="hasError('phone_number')"
                        :error-message="getError('phone_number')" />
                </div>
                <div class="col-12 col-sm-6">
                    <q-input
                        dense
                        outlined
                        :class="{ 'is-invalid': hasError('email') }"
                        name="email"
                        id="email"
                        label="Ваш email"
                        v-model="email"
                        @input="clearError('email')"
                        :error="hasError('email')"
                        :error-message="getError('email')" />
                </div>
                <div class="col-12 col-sm-12">
                    <q-input
                        dense
                        outlined
                        type="textarea"
                        :class="{ 'is-invalid': hasError('comment') }"
                        name="comment"
                        id="comment"
                        label="Ваши пожелания"
                        v-model="comment"
                        @input="clearError('comment')"
                        :error="hasError('comment')"
                        :error-message="getError('comment')" />
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
    import phoneNumberMixin from './../../../mixins/phone_number';
    import promoCode from "./../../../mixins/promo_code";

    export default {
        name: 'CartDeliveryContact',
        mixins: [
            phoneNumberMixin,
            promoCode,
        ],
        data () {
            return {
                fillMask: false,
            };
        },
        watch: {
            stepTwoValid (newValue) {
                if (newValue) {
                    this.setErrors({});
                }
            },
            'errors' (errors) {
                if (_.intersection(_.keys(errors), ['first_name', 'last_name', 'phone_number', 'email']).length) {
                    this.$nextTick(() => {
                        this.$refs.cartDeliveryContact.scrollIntoView({ block: 'start', behavior: 'smooth' });
                    });
                }
            },
        },
        methods: {
            ...mapMutations('cart', [
                'setFormValue',
                'setErrors',
                'clearError',
            ]),
            ...mapActions('cart', [
                'checkCustomer',
            ]),
            onBlurPhoneNumber () {
                this.blurPhoneNumber();
            },
            getPhoneNumber () {
                return this.phone_number;
            },
            setPhoneNumberCallback () {
                this.phone_number = '';
            },
            inputPhoneNumber(value) {
                this.clearError('phone_number');

                if (this.promoCodeForm.promo_code.length) {
                    let original = value;
                    value = value.replace(/[^0-9]+/gm, '');

                    if (value.length === 11) {
                        this.promoCodeForm.phone_number = original;
                        this.applyPromoCode();
                    }
                }
            }
        },
        computed: {
            ...mapState('auth', [
                'logged',
            ]),
            ...mapState('cart', [
                'promoCode',
                'form',
                'errors',
            ]),
            ...mapGetters('cart', [
                'stepTwoValid',
                'submittable',
                'hasError',
                'getError',
            ]),
            email: {
                get () {
                    return this.$store.state.cart.form.email;
                },
                set (value) {
                    this.$store.commit('cart/setFormValue', {
                        key: 'email',
                        value: value
                    });
                }
            },
            phone_number: {
                get () {
                    return this.$store.state.cart.form.phone_number;
                },
                set (value) {
                    this.$store.commit('cart/setFormValue', {
                        key: 'phone_number',
                        value: value
                    });
                }
            },
            first_name: {
                get () {
                    return this.$store.state.cart.form.first_name;
                },
                set (value) {
                    this.$store.commit('cart/setFormValue', {
                        key: 'first_name',
                        value: value
                    });
                }
            },
            middle_name: {
                get () {
                    return this.$store.state.cart.form.middle_name;
                },
                set (value) {
                    this.$store.commit('cart/setFormValue', {
                        key: 'middle_name',
                        value: value
                    });
                }
            },
            last_name: {
                get () {
                    return this.$store.state.cart.form.last_name;
                },
                set (value) {
                    this.$store.commit('cart/setFormValue', {
                        key: 'last_name',
                        value: value
                    });
                }
            },
            comment: {
                get () {
                    return this.$store.state.cart.form.comment;
                },
                set (value) {
                    this.$store.commit('cart/setFormValue', {
                        key: 'comment',
                        value: value
                    });
                }
            }
        }
    }
</script>
